'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _doctifyLogo = require('../../src/styles/doctify-logo.scss');

var _doctifyLogo2 = _interopRequireDefault(_doctifyLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGO_SIZE_EXTRA_SMALL = 'LOGO_SIZE_EXTRA_SMALL';
var LOGO_SIZE_SMALL = 'LOGO_SIZE_SMALL';
var LOGO_SIZE_MEDIUM = 'LOGO_SIZE_MEDIUM';
var LOGO_SIZE_LARGE = 'LOGO_SIZE_LARGE';

var LOGO_THEME_WHITE = 'LOGO_THEME_WHITE';
var LOGO_THEME_BLACK_AND_WHITE = 'LOGO_THEME_BLACK_AND_WHITE';
var LOGO_THEME_COLORED = 'LOGO_THEME_COLORED';

var LOGO_TYPE_WORD = 'LOGO_TYPE_WORD';
var LOGO_TYPE_ICON = 'LOGO_TYPE_ICON';

var DoctifyLogo = function DoctifyLogo(props) {
    var styles = props.classNames ? (0, _extends3.default)({}, _doctifyLogo2.default, props.classNames) : _doctifyLogo2.default;
    return _react2.default.createElement(
        'i',
        { className: styles['logo'] + ' ' + styles[props.logoType] + ' ' + styles[props.logoSize] + ' ' + styles[props.logoTheme] },
        '\xA0'
    );
};

DoctifyLogo.propTypes = {
    logoSize: _propTypes2.default.string,
    logoTheme: _propTypes2.default.oneOf([LOGO_THEME_WHITE, LOGO_THEME_BLACK_AND_WHITE, LOGO_THEME_COLORED]),
    logoType: _propTypes2.default.oneOf([LOGO_TYPE_WORD, LOGO_TYPE_ICON])
};

DoctifyLogo.defaultProps = {
    logoSize: LOGO_SIZE_MEDIUM,
    logoTheme: LOGO_THEME_COLORED,
    logoType: LOGO_TYPE_WORD
};

DoctifyLogo.LOGO_SIZE_EXTRA_SMALL = LOGO_SIZE_EXTRA_SMALL;
DoctifyLogo.LOGO_SIZE_SMALL = LOGO_SIZE_SMALL;
DoctifyLogo.LOGO_SIZE_MEDIUM = LOGO_SIZE_MEDIUM;
DoctifyLogo.LOGO_SIZE_LARGE = LOGO_SIZE_LARGE;
DoctifyLogo.LOGO_THEME_TRANSPARENT = LOGO_THEME_WHITE;
DoctifyLogo.LOGO_THEME_BLACK_AND_WHITE = LOGO_THEME_BLACK_AND_WHITE;
DoctifyLogo.LOGO_THEME_FILLED = LOGO_THEME_COLORED;
DoctifyLogo.LOGO_THEME_COLORED = LOGO_THEME_COLORED;
DoctifyLogo.LOGO_TYPE_WORD = LOGO_TYPE_WORD;
DoctifyLogo.LOGO_TYPE_ICON = LOGO_TYPE_ICON;

exports.default = DoctifyLogo;